<template>
  <!-- 使用 Vant Popup 实现弹窗 -->
  <van-popup v-model="open" position="bottom" closeable :style="{ height: '90%' }" round>
    <div class="add-image-library">
      <div class="header">
        <h3 class="title">{{ title }}</h3>
      </div>

      <van-form ref="form" style="flex: 1; overflow-y: auto; padding: 0 16px;">
        
        <!-- 图片名称 -->
        <van-field
          v-model="form.name"
          name="name"
          label="图片名称"
          placeholder="请输入图片名称"
          :rules="[{ required: true, message: '请输入图片名称' }]"
        />

        <!-- 内容 -->
        <van-field
          v-model="form.content"
          name="content"
          label="内容"
          type="textarea"
          placeholder="请输入内容"
          rows="3"
          autosize
        />

        <!-- 类型选择 - 改为点击弹出复选框 -->
        <van-field
          name="selectType"
          label="类型"
          :value="selectTypeNames"
          placeholder="请选择最多2个类型"
          readonly
          is-link
          @click="showTypePopup = true"
        />

        <!-- 弹出层：类型选择（最多2个） -->
        <van-popup v-model="showTypePopup" position="bottom" round closeable :style="{ height: '50%' }" get-container="body">
          <div class="checkbox-picker">
            <div class="picker-header">
              <h3 style="width: 100%;text-align: center;">选择类型（最多2个）</h3>
              <van-button size="small" type="primary" @click="confirmTypeSelection">确 定</van-button>
            </div>
            <van-checkbox-group v-model="selectType" @change="onTypeChange" style="padding: 16px; max-height: calc(100% - 60px); overflow-y: auto;">
              <van-checkbox
                v-for="item in typeList"
                :key="item.id"
                :name="item.id"
                shape="round"
                style="margin-bottom: 10px;"
              >
                {{ item.type }}
              </van-checkbox>
            </van-checkbox-group>
          </div>
        </van-popup>

        <!-- 图片上传 -->
        <van-field name="url" label="图片">
          <template #input>
            <image-upload v-model="form.url" :isShowTip="true" :limit="btnShow ? 9 : 1" />
          </template>
        </van-field>

      </van-form>

      <!-- 操作按钮 -->
      <div class="dialog-footer" style="padding: 16px">
        <van-button block type="primary" @click="submitForm">确 定</van-button>
        <van-button block style="margin-top: 10px" @click="cancel">取 消</van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { imageLibraryAdd, imageLibraryUpd } from "@/api/imageLibrary";
import { imageTypeList } from "@/api/imageType";

export default {
  data() {
    return {
      title: "",
      open: false,
      form: {},
      btnShow: false,
      typeList: [],
      selectType: [], // 选中的类型 id 数组
      showTypePopup: false, // 控制类型弹窗显示
    };
  },
  computed: {
    // 显示已选类型名称
    selectTypeNames() {
      const selected = this.typeList.filter(item => this.selectType.includes(item.id));
      return selected.map(item => item.type).join(', ') || '';
    }
  },
  methods: {
    addCreateForm(platForm, userName) {
      this.reset();
      this.open = true;
      this.title = "添加图片";
      this.btnShow = true;
      this.form.platForm = platForm;
      this.form.createUser = userName;
      this.getTypeList();
    },
    showCreateForm(record) {
      this.reset();
      this.open = true;
      this.form = { ...record };

      // 初始化已选类型
      if (record.imageTypeList && record.imageTypeList.length > 0) {
        this.selectType = record.imageTypeList.map(item => item.id);
      }

      this.title = "修改图片";
      this.btnShow = false;
      this.getTypeList();
    },
    getTypeList() {
      imageTypeList({
        pageNum: 1,
        pageSize: 1000,
        platForm: this.form.platForm,
      }).then((response) => {
        const result = response.data.data;
        this.typeList = result.list || [];
      });
    },
    reset() {
      this.selectType = [];
      this.form = {
        id: null,
        content: null,
        name: null,
        imageTypeList: [],
        urls: null,
        url: null,
      };
    },
    onTypeChange(values) {
      if (values.length > 2) {
        this.$toast({ type: 'warning', message: '最多只能选择2个类型！', duration: 1500 });
        // 截取前两个
        this.selectType = values.slice(0, 2);
      }
    },
    confirmTypeSelection() {
      // 更新 form.imageTypeList
      const selectedItems = this.typeList.filter(item => this.selectType.includes(item.id));
      this.form.imageTypeList = selectedItems;
      this.showTypePopup = false;
    },
    submitForm() {
      if (!this.form.name) {
        this.$toast.fail("请填写图片名称");
        return;
      }
      if (!this.form.url) {
        this.$toast.fail("请上传图片");
        return;
      }

      this.form.urls = this.form.url.split(",");

      if (this.form.id != null) {
        imageLibraryUpd(this.form).then((response) => {
          if (response.data.code == 200) {
            this.$toast.success("修改成功");
            this.open = false;
            this.$emit("ok");
          }
        });
      } else {
        imageLibraryAdd(this.form).then((response) => {
          if (response.data.code == 200) {
            this.$toast.success("新增成功");
          }
          this.open = false;
          this.$emit("ok");
        });
      }
    },
    cancel() {
      this.open = false;
      this.$emit("ok");
    }
  }
};
</script>

<style scoped>
.add-image-library {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f7f8fa;
}

.header {
  text-align: center;
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fff;
}

.header .title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.dialog-footer {
  background-color: #fff;
  padding: 16px;
  border-top: 1px solid #f0f0f0;
}

.van-form {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background-color: #fff;
  border-radius: 12px;
  margin-bottom: 16px;
}

.van-field__label {
  width: 90px !important;
  color: #333;
  font-weight: 500;
}

.van-cell {
  font-size: 14px;
}

/* 多选弹窗样式 */
.checkbox-picker {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.picker-header {
  padding: 16px;
  text-align: right;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fff;
}

.picker-header h3 {
  margin: 0 0 8px 0;
  font-size: 16px;
  color: #333;
}
</style>